import { OnboardingModuleEnum } from '../types/onboarding.types';

const STORAGE_PREFIX = 'onboarding_seen_';

export type OnboardingStorageAdapter = {
    getItem: (key: string) => string | null | Promise<string | null>;
    setItem: (key: string, value: string) => void | Promise<void>;
    removeItem: (key: string) => void | Promise<void>;
};

/** Default adapter for web (localStorage) */
const webStorage: OnboardingStorageAdapter = {
    getItem: (key: string) => {
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem: (key: string, value: string) => {
        try {
            localStorage.setItem(key, value);
        } catch {
            /* quota exceeded – silently ignore */
        }
    },
    removeItem: (key: string) => {
        try {
            localStorage.removeItem(key);
        } catch {
            /* ignore */
        }
    },
};

let storage: OnboardingStorageAdapter = webStorage;

/** Replace the default localStorage adapter (e.g. with AsyncStorage for RN) */
export function setOnboardingStorage(adapter: OnboardingStorageAdapter): void {
    storage = adapter;
}

function storageKey(module: OnboardingModuleEnum): string {
    return `${STORAGE_PREFIX}${module}`;
}

/** Returns true if the module's onboarding has already been shown */
export async function hasSeenModule(
    module: OnboardingModuleEnum,
): Promise<boolean> {
    const value = await storage.getItem(storageKey(module));
    return value === '1';
}

/** Mark the module's onboarding as completed */
export async function markModuleSeen(
    module: OnboardingModuleEnum,
): Promise<void> {
    await storage.setItem(storageKey(module), '1');
}

/** Reset the module so the onboarding will play again */
export async function resetModule(
    module: OnboardingModuleEnum,
): Promise<void> {
    await storage.removeItem(storageKey(module));
}
